export const fieldLabels = {
  requestType: "Request type",
  requestSubType: "Request sub-type",
  subject: "Message subject",
  message: "Message",
  resourceTags: "Tags",
  allowAoReassignment:"The AO can reassign this message",
  permissions: "Ofqual Permissions",
  visibleToAllStaff: "Visible to all staff",
  orgs: "Organisations",
  roles: "Roles",
};
